<template>  
  <md-field>
    <label for="filter">I tuoi shop</label>
    <md-input name="filter" id="filter" autocomplete="filter" v-model="filter" />
  </md-field>
</template>

<script>
export default {
  name: 'FilterShops',
  data() {
    return {
      filter: null
    }
  },
  mounted() {
    
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/modules/common/components/checkin/FilterShops.vue